import { lazy } from "react";
import { RouteObject } from "react-router-dom";
const AuthLayout = lazy(() => import("../layouts/AuthLayout"));
const WarehouseLayout = lazy(() => import("../layouts/WarehouseLayout"));
const AccountType = lazy(() => import("../pages/Auth-Pages/AccountType"));
const ChosenFacility = lazy(() => import("../pages/Auth-Pages/ChosenFacility"));
const CreatePassword = lazy(() => import("../pages/Auth-Pages/CreatePassword"));
const NewNumber = lazy(() => import("../pages/Auth-Pages/NewNumber"));
const Profile = lazy(() => import("../pages/Auth-Pages/Profile"));
const VerifyOtp = lazy(() => import("../pages/Auth-Pages/VerifyOtp"));
const DrugsCards = lazy(() => import("../pages/Drugs/Cards"));
const ImportDrugsExcel = lazy(() => import("../pages/Drugs/ImportDrugsExcel"));
const DrugsList = lazy(() => import("../pages/Drugs/List"));
const NewDrug = lazy(() => import("../pages/Drugs/NewDrug"));
const ViewDrugDetails = lazy(() => import("../pages/Drugs/ViewDrugDetails"));
const ErrorPage = lazy(() => import("../pages/ErrorPages/ErrorPage"));
const InternalServerErrorPage = lazy(
  () => import("../pages/ErrorPages/InternalServerErrorPage"),
);
const Home = lazy(() => import("../pages/Home/Warehouse/WarehouseHome"));
const RequestDetails = lazy(
  () => import("../pages/Home/Warehouse/RequestDetails"),
);
const TimeOverRequestReview = lazy(
  () => import("../pages/Home/Warehouse/TimeOverRequestReview"),
);
const Notifications = lazy(
  () => import("../pages/Notifications/Notifications"),
);
const OfferList = lazy(() => import("../pages/Offers/Warehouse/List"));
const NewOffer = lazy(() => import("../pages/Offers/Warehouse/NewOffer"));
const OfferDetails = lazy(
  () => import("../pages/Offers/Warehouse/OfferDetails"),
);
const WarehouseOrdersList = lazy(
  () => import("../pages/Orders/Warehouse/List"),
);
const OrdersDetails = lazy(
  () => import("../pages/Orders/Warehouse/OrderDetails"),
);
const ProductsCards = lazy(() => import("../pages/Products/Warehouse/Cards"));
const EditProduct = lazy(
  () => import("../pages/Products/Warehouse/EditProduct"),
);
const ImportProductsExcel = lazy(
  () => import("../pages/Products/Warehouse/ImportProductsExcel"),
);
const ProductsList = lazy(() => import("../pages/Products/Warehouse/List"));
const NewProduct = lazy(() => import("../pages/Products/Warehouse/NewProduct"));
const ViewProductDetails = lazy(
  () => import("../pages/Products/Warehouse/ViewProductDetails"),
);
const HelpCenter = lazy(() => import("../pages/Settings/HelpCenter"));
const NotificationsSettings = lazy(
  () => import("../pages/Settings/NotificationsSettings"),
);
const PrivacyPolicy = lazy(() => import("../pages/Settings/PrivacyPolicy"));
const TermsAndConditions = lazy(
  () => import("../pages/Settings/TermsAndConditions"),
);
const WarehouseStaffList = lazy(() => import("../pages/Staff/Warehouse/List"));
const ISVerifiedGuard = lazy(() => import("./ISVerifiedGuard"));
const ForgetPassword = lazy(() => import("../pages/Auth-Pages/ForgetPassword"));
export const warehouseRoutes: RouteObject[] = [
  {
    path: "",
    index: true,
    element: (
      <WarehouseLayout>
        <Home />
      </WarehouseLayout>
    ),
  },
  {
    path: "profile",
    element: (
      <WarehouseLayout>
        <Profile />
      </WarehouseLayout>
    ),
  },
  //?======================== Settings Routes========================
  {
    path: "settings/help-center",
    element: (
      <WarehouseLayout>
        <HelpCenter />
      </WarehouseLayout>
    ),
  },
  {
    path: "settings/terms-and-conditions",
    element: (
      <WarehouseLayout>
        <TermsAndConditions />
      </WarehouseLayout>
    ),
  },
  {
    path: "settings/privacy-policy",
    element: (
      <WarehouseLayout>
        <PrivacyPolicy />
      </WarehouseLayout>
    ),
  },
  // {
  //   path: "settings/notifications-center",
  //   element: (
  //     <WarehouseLayout>
  //       <NotificationsSettings />
  //     </WarehouseLayout>
  //   ),
  // },

  //?======================== Product Routes========================
  {
    path: "products/list",
    element: (
      <WarehouseLayout>
        <ISVerifiedGuard>
          <ProductsList />
        </ISVerifiedGuard>
      </WarehouseLayout>
    ),
  },
  {
    path: "products/cards",
    element: (
      <WarehouseLayout>
        <ISVerifiedGuard>
          <ProductsCards />
        </ISVerifiedGuard>
      </WarehouseLayout>
    ),
  },
  {
    path: "products/new-product",
    element: (
      <WarehouseLayout>
        <ISVerifiedGuard>
          <NewProduct />
        </ISVerifiedGuard>
      </WarehouseLayout>
    ),
  },
  {
    path: "products/edit-product/:id",
    element: (
      <WarehouseLayout>
        <ISVerifiedGuard>
          <EditProduct />
        </ISVerifiedGuard>
      </WarehouseLayout>
    ),
  },
  {
    path: "products/import-excel",
    element: (
      <WarehouseLayout>
        <ISVerifiedGuard>
          <ImportProductsExcel />
        </ISVerifiedGuard>
      </WarehouseLayout>
    ),
  },
  {
    path: "products/details/:id",
    element: (
      <WarehouseLayout>
        <ISVerifiedGuard>
          <ViewProductDetails />
        </ISVerifiedGuard>
      </WarehouseLayout>
    ),
  },
  //?========================Drugs Routes========================
  {
    path: "drugs/list",
    element: (
      <WarehouseLayout>
        <ISVerifiedGuard>
          <DrugsList />
        </ISVerifiedGuard>
      </WarehouseLayout>
    ),
  },
  {
    path: "drugs/cards",
    element: (
      <WarehouseLayout>
        <ISVerifiedGuard>
          <DrugsCards />
        </ISVerifiedGuard>
      </WarehouseLayout>
    ),
  },
  {
    path: "drugs/new-drug",
    element: (
      <WarehouseLayout>
        <ISVerifiedGuard>
          <NewDrug />
        </ISVerifiedGuard>
      </WarehouseLayout>
    ),
  },
  // {
  //   path: "drugs/import-excel",
  //   element: (
  //     <WarehouseLayout>
  //       <ISVerifiedGuard>
  //         <ImportDrugsExcel />
  //       </ISVerifiedGuard>
  //     </WarehouseLayout>
  //   ),
  // },
  {
    path: "drugs/details/:id",
    element: (
      <WarehouseLayout>
        <ISVerifiedGuard>
          <ViewDrugDetails />
        </ISVerifiedGuard>
      </WarehouseLayout>
    ),
  },
  //?======================== Orders Routes========================
  {
    path: "orders",
    element: (
      <WarehouseLayout>
        <ISVerifiedGuard>
          <WarehouseOrdersList />
        </ISVerifiedGuard>
      </WarehouseLayout>
    ),
  },
  {
    path: "orders/:id",
    element: (
      <WarehouseLayout>
        <ISVerifiedGuard>
          <OrdersDetails />
        </ISVerifiedGuard>
      </WarehouseLayout>
    ),
  },
  {
    path: "orders/request-details/:id",
    element: (
      <WarehouseLayout>
        <ISVerifiedGuard>
          <RequestDetails />
        </ISVerifiedGuard>
      </WarehouseLayout>
    ),
  },
  {
    path: "orders/request-details/:id/timeout",
    element: (
      <WarehouseLayout>
        <ISVerifiedGuard>
          <TimeOverRequestReview />
        </ISVerifiedGuard>
      </WarehouseLayout>
    ),
  },
  //?======================== Offers Routes========================
  {
    path: "offers",
    element: (
      <WarehouseLayout>
        <ISVerifiedGuard>
          <OfferList />
        </ISVerifiedGuard>
      </WarehouseLayout>
    ),
  },
  {
    path: "offers/new-offer",
    element: (
      <WarehouseLayout>
        <ISVerifiedGuard>
          <NewOffer />
        </ISVerifiedGuard>
      </WarehouseLayout>
    ),
  },
  {
    path: "offers/:id",
    element: (
      <WarehouseLayout>
        <ISVerifiedGuard>
          <OfferDetails />
        </ISVerifiedGuard>
      </WarehouseLayout>
    ),
  },
  //?======================== Admins Routes========================
  {
    path: "admins",
    element: (
      <WarehouseLayout>
        <ISVerifiedGuard>
          <Home />
        </ISVerifiedGuard>
      </WarehouseLayout>
    ),
  },
  //?======================== Staff Routes========================
  {
    path: "staff",
    element: (
      <WarehouseLayout>
        <ISVerifiedGuard>
          <WarehouseStaffList />
        </ISVerifiedGuard>
      </WarehouseLayout>
    ),
  },

  //?======================== Notifications Route========================
  {
    path: "notifications",
    element: (
      <WarehouseLayout>
        <Notifications />
      </WarehouseLayout>
    ),
  },

  //??========================= Security Routes========================
  //??========================= Security Routes========================
  //??========================= Security Routes========================
  //??========================= Security Routes========================
  //??========================= Security Routes========================
  //??========================= Security Routes========================
  //??========================= Security Routes========================
  //??========================= Security Routes========================
  {
    path: "account/forget-password",
    element: (
      <AuthLayout>
        <ForgetPassword OriginType="account" />
      </AuthLayout>
    ),
  },
  {
    path: "account/forget-password/otp",
    element: (
      <AuthLayout>
        <VerifyOtp OriginType="account" />
      </AuthLayout>
    ),
  },
  {
    path: "account/forget-password/create-password",
    element: (
      <AuthLayout>
        <CreatePassword OriginType="account" />
      </AuthLayout>
    ),
  },

  {
    path: "account/update-password",
    element: (
      <AuthLayout>
        <CreatePassword OriginType="account" />
      </AuthLayout>
    ),
  },
  {
    path: "account/new-number",
    element: (
      <AuthLayout>
        <NewNumber OriginType="account" />
      </AuthLayout>
    ),
  },
  {
    path: "account/new-number/otp",
    element: (
      <AuthLayout>
        <VerifyOtp OriginType="account" />
      </AuthLayout>
    ),
  },
  {
    path: "account/new-account",
    element: (
      <AuthLayout>
        <AccountType OriginType="account" />
      </AuthLayout>
    ),
  },
  {
    path: "account/account-facility-type",
    element: (
      <AuthLayout>
        <ChosenFacility OriginType="account" />
      </AuthLayout>
    ),
  },

  //?==========================ERRORPAGE========================
  {
    path: "*",
    element: <ErrorPage />,
  },
  {
    path: "500",
    element: <InternalServerErrorPage />,
  },
];
